import { render } from "./refugee_liveness_verification.html?vue&type=template&id=3e51f6be&external"
import script from "./refugee_liveness_verification.js?vue&type=script&lang=js&external"
export * from "./refugee_liveness_verification.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__